import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingButtons from "./FloatingButtons";
import ScrollProgress from "./ScrollProgress";

export default function Layout({ children, hideChrome = false }) {
  const loc = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [loc.pathname]);

  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      {!hideChrome && <ScrollProgress />}
      {!hideChrome && <Navbar />}
      <main>{children}</main>
      {!hideChrome && <Footer />}
      {!hideChrome && <FloatingButtons />}
    </div>
  );
}
